import { createContext, useContext, useState, useCallback } from 'react';
import translations from './i18n';

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem('eco_lang') || 'kz');

  const setLang = useCallback((l) => {
    setLangState(l);
    localStorage.setItem('eco_lang', l);
  }, []);

  const t = useCallback((key) => {
    const keys = key.split('.');
    let val = translations[lang];
    for (const k of keys) {
      val = val?.[k];
      if (val === undefined) return key;
    }
    return val;
  }, [lang]);

  // Localized field from DB item: l(item, 'name') → item.name_kz or item.name_ru
  const l = useCallback((item, field = 'name') => {
    if (!item) return '';
    const localized = item[`${field}_${lang}`];
    if (localized) return localized;
    // Fallback: try the other language, then bare field
    const other = lang === 'kz' ? 'ru' : 'kz';
    return item[`${field}_${other}`] || item[field] || '';
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, l }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
